import { isNonEmptyString, isNumber } from '../../../utils/checks'
import { reverseObjectKeysAndValues } from '../../../utils/reverseObjectKeysAndValues'
import { ZoneIds } from '../../../domain/zoneIds.ts'
import { segmentZones } from '../../segment/constants'
import {
  MATCHED_BROWSE_TREATS_BOOST_CAP,
  BROWSE_BOOST_PER_TERM,
  MIN_BROWSE_BOOST
} from '../../useCases/score/constants.ts'
const ADMIN_BASE_URL =
  'https://www.sanity.io/@o1u9KmNVm/studio/v06h454i7unxfh5hc475gn86/default/content/'

export const formatAdminLink = (center) => {
  if (isNonEmptyString(center?.slug)) {
    return ADMIN_BASE_URL.concat('?_type=Center&slug=', center.slug.toString())
  }
  return ADMIN_BASE_URL.concat('/center')
}

export const listKevelZoneName = (zoneId) => {
  const zoneNames = reverseObjectKeysAndValues(ZoneIds)
  return zoneNames[zoneId]
}

export const listSegmentName = (zoneId) => {
  return segmentZones[zoneId]
}

export const getAdOpsCookie = () => {
  if (typeof document === 'undefined') {
    return null
  }
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith('adOps'))
    ?.split('=')[1]
}

export const getBrowseBoostCount = (boostScore) =>
  Math.min(
    (boostScore - MIN_BROWSE_BOOST) / BROWSE_BOOST_PER_TERM,
    MATCHED_BROWSE_TREATS_BOOST_CAP
  )
